<template>
  <div class="bg-mentalnc text-gray-700">
    <layouts-auth-width>
      <div class="p-2 h-12 grid grid-cols-12 content-center">
        <div class="col-span-4 flex items-center justify-start">
          <transition name="fade" mode="out-in">
            <template v-if="!store.state.menu.sidebar.open">
              <base-svg-icon @click="store.dispatch('menu/switchSidebarOpen')" class="w-7 cursor-pointer" :path="mdiMenu" />
            </template>
            <template v-else>
              <base-svg-icon @click="store.dispatch('menu/switchSidebarOpen')" class="w-7 cursor-pointer" :path="mdiClose" />
            </template>
          </transition>
        </div>
        <div class="col-span-4 flex items-center justify-center">
          <router-link :to="homePath">
            <img class="w-11" src="@/assets/images/header_logo.png" alt="LOGO">
          </router-link>
        </div>
        <div v-if="props.is_well_labo" class="col-span-4 flex items-center justify-end">
          <a :href="wellLaboUrl">
            <base-icon-text :path="mdiPlayCircle" :text="t('word.well_labo')" iconClass="text-wellLabo" :open="true" />
          </a>
        </div>
      </div>
    </layouts-auth-width>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from '@/store/index'
import { mdiMenu, mdiClose, mdiPlayCircle } from '@mdi/js'
import { HOME_PATH } from '@/router/routes'

import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
import BaseIconText from '@/components/BaseIconText.vue'

export default defineComponent({
  components: {
    LayoutsAuthWidth,
    BaseSvgIcon,
    BaseIconText
  },
  props: {
    is_well_labo: {
      type: Boolean
    }
  },
  setup(props) {
    const { t } = useI18n()
    const store = useStore()

    return {
      t,
      store,
      mdiMenu,
      mdiClose,
      mdiPlayCircle,
      homePath: HOME_PATH,
      wellLaboUrl: process.env.VUE_APP_WELL_LABO_URL,
      props
    }
  },
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
